import React from "react";
import { Construction } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, PageBody } from "./_PageShell";

export default function ComingSoon({ moduleKey = "deal", title = "Deals", description = "Drag-and-drop pipeline.", labelOverride }) {
  const { workspace } = useAuth();
  const label = labelOverride || workspace?.labels?.[moduleKey] || title;

  return (
    <>
      <PageHeader
        eyebrow={`CRM · ${title}`}
        title={`${label}${title === "Activities" ? "" : "s"}`}
        description={description}
      />
      <PageBody>
        <div className="rounded-2xl border border-[#E8E6E1] bg-[#FDFCFB] p-10 md:p-14 text-center max-w-2xl mx-auto">
          <div className="w-12 h-12 mx-auto mb-6 rounded-2xl bg-[#1A1A1A] text-[#FDFCFB] flex items-center justify-center">
            <Construction className="w-5 h-5" />
          </div>
          <div className="caption mb-3">Coming next</div>
          <h2 className="font-serif-display text-3xl md:text-4xl tracking-tight text-[#1A1A1A]">
            {title} is on the way.
          </h2>
          <p className="mt-4 text-sm text-[#6B6A68] leading-relaxed max-w-md mx-auto">
            We just shipped Auth, Workspaces, Contacts and Companies. Pipelines &
            Kanban (Deals) and Tasks/Calendar (Activities) land in the next
            chunk.
          </p>
        </div>
      </PageBody>
    </>
  );
}
